import React, { useContext, useMemo, useState } from "react";

export const GroupUsersContext = React.createContext({});
export const GroupUsersActionContext = React.createContext({});

export const useGroupUsersState = () => {
  return useContext(GroupUsersContext);
};

export const useGroupUsersDispatch = () => {
  return useContext(GroupUsersActionContext);
};

export default ({ children }) => {
  const [state, setCurrentState] = useState({
    loadingGroup: true,
    reloadTreeFlag: 0
  });

  const action = useMemo(() => {
    return {
      setCurrentGroup: info => {
        setCurrentState(preState => ({
          ...preState,
          loadingGroup: false,
          currentGroup: info
        }));
      },
      updateCurrentGroup: info => {
        setCurrentState(preState => ({
          ...preState,
          currentGroup: { ...preState.currentGroup, ...info }
        }));
      },
      setLoadingGroup: bool => {
        setCurrentState(preState => ({
          ...preState,
          loadingGroup: bool
        }));
      },
      reloadCategoryTree: () => {
        setCurrentState(preState => ({
          ...preState,
          reloadTreeFlag: preState.reloadTreeFlag + 1
        }));
      },
      // 设置当前选择的公司
      setCurrentCompany : (companyId,companyName) => {
        setCurrentState(preState => ({
          ...preState,
          currentCompanyId: companyId,
          currentCompanyName: companyName
        }))
      },
    };
  }, []);

  return (
    <GroupUsersContext.Provider value={state}>
      <GroupUsersActionContext.Provider value={action}>
        {children}
      </GroupUsersActionContext.Provider>
    </GroupUsersContext.Provider>
  );
};
